export default __webpack_public_path__ + "48341460a3e23ceec674de4ccd941a2e.svg";